import { BigNumber } from 'ethers'
import { SECONDS_IN_WEEK } from '~/lib/constants'
import { getVESISAPR } from '~/lib/getVESISAPR'
import { SimpleFraction } from '~/lib/SimpleFraction'
import { Locked } from '../useLockChangeDetails'

interface Stats {
	totalRewards: BigNumber
	apr: number
}

interface Result {
	stats?: Stats
	change?: Stats
}

function calculateStats(locked: Locked, additionalDuration = 0): Stats {
	const weeklyRewards = locked.veSISBalance
		.mul(locked.tokensPerWeek)
		.div(locked.totalVESISSupply)

	const now = Math.floor(Date.now() / 1000)
	const totalDuration = new SimpleFraction(
		locked.end.add(additionalDuration * SECONDS_IN_WEEK).sub(now),
		SECONDS_IN_WEEK
	).toBigNumber()

	const totalRewards = weeklyRewards.mul(totalDuration)
	const apr = getVESISAPR(weeklyRewards, locked.amount)

	return {
		apr,
		totalRewards,
	}
}

export function useNewUnlockChanges(
	locked: Locked | undefined,
	duration: number
): Result {
	if (!locked) {
		return {}
	}

	const stats = calculateStats(locked)
	const newStats = calculateStats(locked, duration)

	return {
		change: {
			apr: newStats.apr - stats.apr,
			totalRewards: newStats.totalRewards.sub(stats.totalRewards),
		},
		stats: newStats,
	}
}
